import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Lenis from "lenis";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SITE_SCHEMA } from "./Seo";
import { trackPageView } from "../lib/track";

export const DisclosureBanner = () => (
  <div className="border-b border-slate-200 bg-slate-50 px-6 py-2 text-center" data-testid="affiliate-disclosure-banner">
    <p className="text-[11px] text-slate-500">
      We're reader-supported — buying through our links may earn us a commission at no cost to you.{" "}
      <Link to="/affiliate-disclosure" className="underline hover:text-[#4687FF]">Full disclosure</Link>
    </p>
  </div>
);

export const Layout = ({ children, disclosure = true }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    const id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(SITE_SCHEMA)}</script>
      </Helmet>
      <Header />
      {disclosure && <DisclosureBanner />}
      <main>{children}</main>
      <Footer />
    </div>
  );
};
